import React from "react";
import { fetchQuery as relayFetchQuery } from "react-relay";

import type {
	CacheConfig,
	FetchQueryFetchPolicy,
	GraphQLTaggedNode,
	MutationConfig,
	MutationParameters,
	OperationType,
} from "relay-runtime";

import { environment } from "~/models";

import { commitMutationPromise } from "../relayUtil";

export function fetchQuery<T extends OperationType>(
	query: GraphQLTaggedNode,
	variables: T["variables"],
	cacheConfig?: {
		networkCacheConfig?: CacheConfig | null | undefined;
		fetchPolicy?: FetchQueryFetchPolicy | null | undefined;
	} | null,
): Promise<T["response"] | undefined> {
	return relayFetchQuery(environment, query, variables, cacheConfig).toPromise();
}

export function commitMutation<T extends MutationParameters = MutationParameters>(
	mutationConfig: MutationConfig<T>,
): Promise<T["response"] | undefined> {
	return commitMutationPromise(environment, mutationConfig);
}

export default function GraphQL() {
	React.useEffect(() => {
		if (window.electron?.registerFetchQuery) {
			window.electron?.registerFetchQuery(fetchQuery);
		}
		if (window.electron?.registerCommitMutation) {
			window.electron?.registerCommitMutation(commitMutation);
		}
	}, []);

	return <></>;
}
